function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 566.93 566.93"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M281.71 45.93c-102.31 0-185.26 81.87-185.26 182.86s185.26 300.42 185.26 300.42 185.26-199.42 185.26-300.42S384.02 45.93 281.71 45.93m0 273.86c-48.93 0-88.6-39.67-88.6-88.6s39.67-88.6 88.6-88.6 88.6 39.67 88.6 88.6-39.67 88.6-88.6 88.6m0 0",
    style: {
      fill: "#d90b17"
    }
  }));
};
export default SvgLocation;